import { render } from "./InvoiceDaysTillChip.vue?vue&type=template&id=051fa3d8"
import script from "./InvoiceDaysTillChip.vue?vue&type=script&lang=js"
export * from "./InvoiceDaysTillChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__